import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { Menu } from '../Menu';
import { Customer } from '@app/models/customers/Customer';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-menu2',
    templateUrl: './menu2.component.html',
    styleUrls: ['./menu2.component.scss'],
    standalone: false
})
export class Menu2Component implements OnInit {
    menutype = input<string>('5'); // 1 = reisebuero 2 = urlaubssuchen 3 = urlaubsziele 4 = extra 5 = all  // only deskmode
    currentCustomer: Customer;

    offerpackCount: number = 0;
    destroyRef = inject(DestroyRef);

    constructor(
        protected mymenu: Menu,
        protected mediaService: MediaService
    ) { }

    ngOnInit(): void {
        // console.log(this.mymenu?.menuurlaubssuchen)
    }
}
